// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*그날의 예약 목록 팝업*/
.CalendarMorePopup_calendar_more_popup__CWeEC {
    position: absolute;
    width: 249px;
    height: 334px;
    border-radius: 20px;
    background: #FFF;
    box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);
    padding: 17px 20px; box-sizing: border-box;
    z-index: 9999;
    display: block;
}

.CalendarMorePopup_calendar_more_popup__CWeEC .CalendarMorePopup_tit__v8D32{
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 15px;
    display: flex;
}

.CalendarMorePopup_calendar_more_popup__CWeEC .CalendarMorePopup_tit__v8D32 .CalendarMorePopup_close_btn__QghEL {margin-left: auto;cursor: pointer;}
.CalendarMorePopup_calendar_more_popup__CWeEC .CalendarMorePopup_tit__v8D32 .CalendarMorePopup_close_btn__QghEL svg{position: relative; top: 2px;}
.CalendarMorePopup_calendar_more_popup__CWeEC .CalendarMorePopup_tit__v8D32 .CalendarMorePopup_name__MMTRo{color: #51D7DF;}

.CalendarMorePopup_calendar_more_popup__CWeEC > span{color: #51D7DF; margin-bottom: 9px;}`, "",{"version":3,"sources":["webpack://./src/components/CalendarMorePopup.module.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAER,gDAAgD;IACxD,kBAAkB,EAAkC,sBAAsB;IAC1E,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IAGnB,aAAa;AACjB;;AAEA,iHAAsC,iBAAiB,CAAC,eAAe,CAAC;AACxE,oHAAyC,kBAAkB,EAAE,QAAQ,CAAC;AACtE,2GAAgC,cAAc,CAAC;;AAE/C,qDAA4B,cAAc,EAAE,kBAAkB,CAAC","sourcesContent":["/*그날의 예약 목록 팝업*/\n.calendar_more_popup {\n    position: absolute;\n    width: 249px;\n    height: 334px;\n    border-radius: 20px;\n    background: #FFF;\n    -webkit-box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);\n            box-shadow: 4px 4px 20px 0px rgba(0, 0, 0, 0.25);\n    padding: 17px 20px; -webkit-box-sizing: border-box; box-sizing: border-box;\n    z-index: 9999;\n    display: block;\n}\n\n.calendar_more_popup .tit{\n    font-size: 16px;\n    font-weight: 700;\n    margin-bottom: 15px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.calendar_more_popup .tit .close_btn {margin-left: auto;cursor: pointer;}\n.calendar_more_popup .tit .close_btn svg{position: relative; top: 2px;}\n.calendar_more_popup .tit .name{color: #51D7DF;}\n\n.calendar_more_popup > span{color: #51D7DF; margin-bottom: 9px;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendar_more_popup": `CalendarMorePopup_calendar_more_popup__CWeEC`,
	"tit": `CalendarMorePopup_tit__v8D32`,
	"close_btn": `CalendarMorePopup_close_btn__QghEL`,
	"name": `CalendarMorePopup_name__MMTRo`
};
export default ___CSS_LOADER_EXPORT___;
